module.exports = __webpack_public_path__ + "static/media/finished-img3.94055b2a.png";